// Servicio de estado de carga global — fuente única del indicador de loading.
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  // Contador de peticiones activas para soportar requests simultáneos
  private activeRequests = 0;

  private readonly _isLoading = signal<boolean>(false);
  readonly isLoading = this._isLoading.asReadonly();

  /** Marca el inicio de una petición */
  show(): void {
    this.activeRequests++;
    this._isLoading.set(true);
  }

  /** Marca el fin de una petición */
  hide(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    if (this.activeRequests === 0) {
      this._isLoading.set(false);
    }
  }
}
